// Util

import util from './util'
import store from './store'

// Dependencies

// Components

import MainContainer from './component-main'
import StickyHeader from './component-sticky-header'
import ProgressBar from './component-progress-bar'
import Intro from './component-intro'
import OutroNavigation from './component-outro'
import GenericList from './component-list'
import TaggedPosts from './component-tagged-posts'
import RelatedReading from './component-related'
import Loading from './component-loading'
import Lightbox from './component-lightbox'
import Footnotes from './component-footnotes'
import SingleTimeline from './component-single-timeline'
import Timeline from './component-timeline'
import Publications from './component-publications'
import Lexicon from './component-lexicon'
import Author from './component-author'
import Authors from './component-authors'
import MarginFootnote from './component-up-arrow'
import Link from './component-link'
import ACFPosts from './component-acf-posts'

Vue.use(store)

// Module

let init = () => {

window.vm = new Vue({
		el: '#root',
		store: store,
		data: {
			sections: store.state.sections,
			lastSectionHeight: 0,
			menu: store.state.menu,
			css: window.sashimi,
			bigTextSize: null,
			smallTextSize: null,
			resizing: false,
			mainHeight: 0,
			loading: true
		},
		computed: {
			rootClasses: function() {
				return {
					'no-transitions': this.resizing
				}
			},
			introClass: function() {
				return {
					'long-intro': this.$store.state.loopHelper.isIntro,
					'long-intro--fade-in': !this.$store.state.loopHelper.isIntro
				}
			},
			largeTypoScaling: function() {
				if (!this.$store.state.loopHelper.pixelHasFadeOut) {
					this.largeTypoStable = 'scale(1)'
					return {
						transform: 'scale(1)',
						lineHeight: '1.125em'
					}
				} else if(this.$store.state.loopHelper.fixOutro && this.$store.state.loopHelper.showOutro && !this.$store.state.loopHelper.dismissOutro) {
					this.largeTypoStable = 'scale(1)'
					return {
						transform: 'scale(1)',
						lineHeight: '1.125em'
					}
				} else {
					let size = this.smallTextSize / this.bigTextSize
					this.largeTypoStable = 'scale(' + size + ')'
					return {
						transform: 'scale(' + size + ')',
						lineHeight: '1.3em'
					}
				}
			}
		},
		methods: {
			clickLink: util.onClickDefaultLink,
			clickIntroLink: util.onClickIntroLink
		},
		created() {
			window.addEventListener('scroll', onWindowScroll)
			setInterval(() => {
				util.eventBus.$emit('doScrollEvents')
			}, 10);
			//window.stickyfill.init()
			pageLoad();
			util.getMenus().then(function(items) {
				store.commit('loadMenu', items)
			}).catch(function(error) {
				console.log(error)
			})
		},
		mounted() {

			util.setupAjax()
			util.detectMobile()

			// If we entered on a page, update the menus to reflect this
			// Edit: no need, we do this in store
			// if (wp.isPage) {
			// 	util.updateMenuState(wp.id)
			// 	console.log(wp.id)
			// }

			// Reference sizes for typography scaling
			this.bigTextSize = parseInt($(this.$refs['type-big']).css('font-size'))
			this.smallTextSize = parseInt($(this.$refs['type-small']).css('font-size'))

			// Resize handler
			$(window).on('resize', () => {
				this.resizing = true
				this.$forceUpdate()
			})

			$(window).on('resize', debounce(() => {
				this.resizing = false
				this.bigTextSize = parseInt($(this.$refs['type-big']).css('font-size'))
				this.smallTextSize = parseInt($(this.$refs['type-small']).css('font-size'))
			}, 500))

		},
		destroyed() {
			window.removeEventListener('scroll', this.onWindowScroll)
		},
		updated() {
			this.mainHeight = $('#main').height() + 'px'
			this.lastSectionHeight = $('.section').last().height()
			this.$nextTick(() => {

				let self = this

				// Special treatment for links in raw html body
				$('.section-body a.ajax').each(function() {
					let color = util.getRandomColor()
					$(this).data('ajaxified', true)
					$(this).attr('data-color', color)
					$(this).data('color', color)
					$(this).hover(function() {
						$(this).css('color', color)
					}, function() {
						$(this).not('.ajax--clicked').css('color', '#000')
					})
					$(this).on('click', vm.clickLink)
					$(this).removeClass('ajax')
				})

				// Special treatment for inline footnotes
				$('.section-body sup.super').each(function() {

					let $self = $(this)
					let html = $.parseHTML($self.data('footnote-text'))
					let numeral = $self.data('footnote-number')
					let color = $self.closest('section').data('color')

					$self.removeClass('super')

					function hideMarginFootnoteOnScroll() {
						$self.css('color', 'black')
						$self.removeClass('margin-footnote--hovered')
						$self.find('.footnote-figure').removeClass('margin-footnote--hovered')
					}

					function onFootnoteMouseEnter() {
						$self.css('color', color)
						$self.addClass('margin-footnote--hovered')
						$self.find('.footnote-figure').addClass('margin-footnote--hovered')
						$(window).one('scroll', hideMarginFootnoteOnScroll)
					}

					if (self.$store.state.mobile) {
						// Do stuff for mobile
					} else {
						$self.append('<div class="margin-footnote"><span class="footnote-figure" data-footnote-number="' + numeral + '"></span><div class="footnote-text"></div></div>')
						$self.find('.footnote-text').append(html);
						$self.on('click', () => {
								//$self.off('mouseenter', onFootnoteMouseEnter)
								//$(window).off('scroll', hideMarginFootnoteOnScroll)
								let $targetFootnote = $self.closest('.section').find('.footnotes').children('li:nth-child(' + numeral + ')')
								$targetFootnote.css('color', color)
								let scroll = $targetFootnote.offset().top - $(window).height() / 2
								$(window).scrollTop(scroll)
								setTimeout(function () {
									$(window).one('scroll', () => {
										$targetFootnote.css('color', 'black')
									})
								}, 1000);
						})
						$self.on('mouseenter', onFootnoteMouseEnter)
					}
				})

				// Stickyfill
				//window.stickyfill.rebuild()

				util.renderGalleries()

			})


		}
	});

}

// Functions

function pageLoad() {

	if (wp.isHome == false) {

		let ajaxMethod
		let color = util.getRandomColor()

		if (wp.isTag) {
			ajaxMethod = util.getSingleLexicon
		} else if (wp.template == 'page-styleguide.php') {
			ajaxMethod = util.getAll
		} else if (wp.type == 'post') {
			ajaxMethod = util.getSingle
		} else if (wp.type == 'page') {
			ajaxMethod = util.getPage
		} else if (wp.type == 'timeline') {
			ajaxMethod = util.getSingleTimeline
		} else if (wp.type == 'contributors') {
			ajaxMethod = util.getSingleAuthor
		}

		ajaxMethod(wp.id).then((p) => {
			let post = p
			post.doAnimation = true
			post.color = color
			post.slug = wp.queryVars.postname
			store.commit('pushToSections', post)
		}).catch(function(error) {
			console.log(error)
		})

	}
}

function onWindowScroll() {
	store.commit('scroll', window.scrollY)
}

// Window load

window.onload = function() {

	init();

}
